// @ts-nocheck


import moment from 'moment';
import React from 'react';
import { OrgUnitSelect } from '../../../components';
import { DatePicker } from '../../../components/ant/DatePicker';
import { FormField } from '../../../components/Form';
import { StyledInputNumber } from '../../../components/hoc/common/components/elements';

import CommonForm from '../../../components/hoc/common/handbook/CommonForm';
import Grid, { GridItem } from '../../../components/layout/Grid';
import VehicleModelSelect from '../../../components/selects/VehicleModelSelect';


export default (props) => {
  return (
    <CommonForm {...props}>
      {({ setFieldValue, values }) => {
        return (
          <>
            <Grid gutter='16px'>
              <GridItem>
                <FormField label="Подразделение" fast required name="orgUnitId">
                  {({ name, value }) =>
                  <OrgUnitSelect
                    value={value}
                    onlyBranches
                    onChange={(value) => setFieldValue(name, value)} />

                  }
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  required
                  fast
                  label="Модель ТС"
                  name="vehicleModelId">

                  {({ value, name }) =>
                  <VehicleModelSelect
                    value={value}
                    name={name}
                    onChange={async (value) =>
                    setFieldValue(name, value)
                    } />

                  }
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  label="Тариф за превышение допустимой нормы в весенний период без НДС, руб."
                  fast
                  required
                  name="excessRate">

                  {({ name, value }) =>
                  <StyledInputNumber
                    name={name}
                    value={value}
                    onChange={(value) => setFieldValue(name, value)}
                    min={0} />

                  }
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  label="Сумма тарифа компенсации за вред принесённый дорогам без НДС, руб."
                  fast
                  required
                  name="roadDamageRate">

                  {({ name, value }) =>
                  <StyledInputNumber
                    name={name}
                    value={value}
                    onChange={(value) => setFieldValue(name, value)}
                    min={0} />

                  }
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  label="Ставка госпошлины за выдачу пропусков на весенний период без НДС, руб."
                  fast
                  required
                  name="springPassesTax">

                  {({ name, value }) =>
                  <StyledInputNumber
                    name={name}
                    value={value}
                    onChange={(value) => setFieldValue(name, value)}
                    min={0} />

                  }
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  label="Ставка госпошлины за выдачу пропусков (негабарит) без НДС, руб."
                  fast
                  required
                  name="cargoPassesTax">

                  {({ name, value }) =>
                  <StyledInputNumber
                    name={name}
                    value={value}
                    onChange={(value) => setFieldValue(name, value)}
                    min={0} />

                  }
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  label="Ставка госпошлины за согласование пропусков (негабарит) без НДС, руб."
                  fast
                  required
                  name="cargoPassesAgreementTax">

                  {({ name, value }) =>
                  <StyledInputNumber
                    name={name}
                    value={value}
                    onChange={(value) => setFieldValue(name, value)}
                    min={0} />

                  }
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  label="Стоимость бланка, руб."
                  fast
                  required
                  name="blankPrice">

                  {({ name, value }) =>
                  <StyledInputNumber
                    name={name}
                    value={value}
                    onChange={(value) => setFieldValue(name, value)}
                    min={0}
                    step={1}
                    precision={0} />

                  }
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Дата начала" name="startDate" required>
                  {({ name, value }) =>
                  <DatePicker
                    name={name}
                    value={value ? moment(value) : value}
                    format="DD MMMM YYYY"
                    onChange={(value) => {
                      setFieldValue(
                        name,
                        moment.
                        utc(value).
                        startOf('day').
                        toISOString()
                      );
                    }} />

                  }
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Дата окончания" name="endDate" required>
                  {({ name, value }) =>
                  <DatePicker
                    name={name}
                    value={value ? moment(value) : value}
                    format="DD MMMM YYYY"
                    disabled={!values.startDate}
                    disabledDate={(date) =>
                    values.startDate ?
                    moment.
                    utc(date).
                    startOf('day').
                    isSameOrBefore(moment.utc(values.startDate)) :
                    false
                    }
                    onChange={(value) => {
                      setFieldValue(
                        name,
                        moment.
                        utc(value).
                        startOf('day').
                        toISOString()
                      );
                    }} />

                  }
                </FormField>
              </GridItem>
            </Grid>
          </>);

      }}
    </CommonForm>);

};
